import React, { useState, useEffect } from 'react';
// axios removed
import instance from '../../Axios/axiosConfig';
import { load } from '@cashfreepayments/cashfree-js';
import {
  Button,
  Box,
  Container,
  CircularProgress,
} from '@mui/material';
import PaymentIcon from '@mui/icons-material/Payment';

const CashFreePayment = ({ amount, phoneNumber, onSuccess }) => {
  const userEmail = localStorage.getItem('email');
  const name = localStorage.getItem('name');
  const [cashfree, setCashfree] = useState(null);
  // orderId removed
  const [loading, setLoading] = useState(false);


  // updatePremiumStatus removed
  

  // Load Cashfree SDK on mount
  useEffect(() => {
    const initializeSDK = async () => {
      const cf = await load({ mode: 'production' }); // Change to 'sandbox' for testing ''
      setCashfree(cf);
    };
    initializeSDK();
  }, []);

  // Get Session ID from backend
  const getSessionId = async () => {
    try {
      const res = await instance.post('/survey/payment', {
        amount: amount || 99, // Default amount if not provided
        customerPhone: phoneNumber || "",
        customerName: name || 'Just Paste it',
        customerEmail: userEmail,
      });
  
      if (res.data?.payment_session_id) {
        return {
          sessionId: res.data.payment_session_id,
          orderId: res.data.order_id,
        };
      }
    } catch (error) {
      console.error('Error fetching session ID:', error);
    }
  };
  

  // Verify payment
  const verifyPayment = async (orderId) => {
    let attempts = 0;
    const maxAttempts = 10;
  
    const interval = setInterval(async () => {
      try {
        const res = await instance.post('/survey/verify', { orderId });
        const payment = res?.data?.[0];
  
        console.log("🔍 Polling payment status:", payment?.payment_status);
  
        if (!payment) return;
  
        if (payment.payment_status === "SUCCESS" || payment.payment_status === "PAID") {
          clearInterval(interval);
          console.log("✅ Payment successful:", payment);
          // Callback function to update premium status
          await onSuccess();
        }
  
        if (payment.payment_status === "FAILED") {
          clearInterval(interval);
          console.warn("❌ Payment failed:", payment);
          // Optional: show error
        }
  
        if (++attempts >= maxAttempts) {
          clearInterval(interval);
          console.warn("⚠️ Payment verification timed out");
        }
      } catch (error) {
        console.error("Verification error:", error);
        clearInterval(interval);
      }
    }, 3000); // check every 3 seconds
  };
  

  const handlePayment = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
  
      const result = await getSessionId();
      if (!cashfree || !result?.sessionId || !result?.orderId) return;
  
      const checkoutOptions = {
        paymentSessionId: result.sessionId,
        redirectTarget: "_modal",
      };
  
      const checkoutResult = await cashfree.checkout(checkoutOptions);
  
    // console.log("✅ Checkout result:", checkoutResult);
  
      // Check if payment was aborted
      if (checkoutResult?.error?.code === "payment_aborted") {
        console.warn("❌ Payment was aborted by the user.");
        return;
      }
  
      // Proceed to verify only if not aborted
      await verifyPayment(result.orderId);
  
    } catch (error) {
      console.error("Payment error:", error);
    } finally {
      setLoading(false);
    }
  };
  
  

  return (
    <Container maxWidth="sm" sx={{ mt: 6, textAlign: 'center' }}>
      <Box>
        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={<PaymentIcon />}
          onClick={handlePayment}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Pay Now'}
        </Button>
      </Box>
    </Container>
  );
};

export default CashFreePayment;